import Error from "@mui/icons-material/Error";
import { styled } from "@mui/material/styles";

const ErrorIcon = styled(Error)({
    color: "red",
    fontSize: "18px",
    verticalAlign: "text-bottom",
});

export default ErrorIcon;
